import CUnderline from '../../components/CUnderline';
import icon_business_values_1 from '../../assets/banner/home/icon_business_values_1.svg';
import icon_business_values_2 from '../../assets/banner/home/icon_business_values_2.svg';
import icon_business_values_3 from '../../assets/banner/home/icon_business_values_3.svg';
import icon_business_values_4 from '../../assets/banner/home/icon_business_values_4.svg';
import { useTranslation } from 'react-i18next';

const SectionHeroBusinessValues = () => {
    const { t } = useTranslation();

    const businessValues = [
        {
            icon: <img src={icon_business_values_1} alt="" />,
            title: t('business.value1.title'),
            description: t('business.value1.description')
        },
        {
            icon: <img src={icon_business_values_2} alt="" />,
            title: t('business.value2.title'),
            description: t('business.value2.description')
        },
        {
            icon: <img src={icon_business_values_4} alt="" />,
            title: t('business.value4.title'),
            description: t('business.value4.description')
        },
        {
            icon: <img src={icon_business_values_3} alt="" />,
            title: t('business.value3.title'),
            description: t('business.value3.description')
        }
    ];

    return (
        <div className='relative'>
            <section className='business-values'>
                <div className='text-center'>
                    <h2>{t('business.title')}</h2>
                    <div className='underline-container d-flex justify-content-center'>
                        <CUnderline />
                    </div>
                </div>
                <div className='values-container'>
                    {businessValues.map((value, index) => (
                        <div key={index} className='value-item'>
                            <span className='value-icon'>{value.icon}</span>
                            <h3>{value.title}</h3>
                            <p className='fs-15 opacity-75 font-tomorrow'>{value.description}</p>
                        </div>
                    ))}
                </div>

            </section>
        </div>
    )
}

export default SectionHeroBusinessValues;